import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import Email from "@mapmycustomers/shared/types/email/Email";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button, Popconfirm } from "@mapmycustomers/ui";

import { cancelQueuedEmail } from "@app/store/email/actions";

import messages from "./messages";

interface CancelEmailAction {
  email: Email;
}

const CancelEmailAction = ({ email, onCancel }: CancelEmailAction & typeof mapDispatchToProps) => {
  const intl = useIntl();
  const [cancelling, startCancelling, finishCancelling] = useBoolean();

  const handleCancelConfirm = useCallback(() => {
    startCancelling();
    onCancel({
      emailId: email.id,
      finishCallback: finishCancelling,
    });
  }, [email, startCancelling, finishCancelling, onCancel]);

  const disabled = email.status !== EmailStatus.SUBMITTED;

  return (
    <Popconfirm
      cancelText={intl.formatMessage(messages.goBackLabel)}
      danger
      description={intl.formatMessage(messages.cancelSendWarning)}
      disabled={disabled}
      okText={intl.formatMessage(messages.cancelSendLabel)}
      onConfirm={handleCancelConfirm}
      placement="left"
    >
      <Button danger disabled={disabled} loading={cancelling} type="link">
        {intl.formatMessage(messages.cancelSendLabel)}
      </Button>
    </Popconfirm>
  );
};

const mapDispatchToProps = {
  onCancel: cancelQueuedEmail,
};

export default connect(null, mapDispatchToProps)(CancelEmailAction);
